import React from "react"
import { graphql } from "gatsby"
import ReactPlayer from "react-player/lazy"

import RichText from "../RichText"

import { VideoModel } from "../../models/components"

interface VideoProps extends VideoModel {
  cssClass?: string
  pageContext:any
}

const defaultProps = {}

export const Video: React.FC<VideoProps> = props => {
  // console.log("Video: ", props)
  if (!props.video_url) return null

  if (props.caption)
    return (
      <figure className="video embed">
        <VideoPayer {...props} />

        {props.caption && typeof props.caption === "string" && (
          <figcaption>{props.caption}</figcaption>
        )}
        {props.caption && typeof props.caption === "object" && (
          <RichText content={props.caption} figcaption pageContext={props.pageContext}/>
        )}
      </figure>
    )

  return (
    <div className="video embed">
      <VideoPayer {...props} />
    </div>
  )
}

Video.defaultProps = defaultProps

export default Video

const VideoPayer: React.FC<VideoProps> = props => {
  return (
    <div className={`video__player ${props.cssClass || ""}`} data-videosrc={props.video_url}>
      <ReactPlayer
        url={props.video_url}
        config={{
          youtube: {
            playerVars: {
              autoplay: 0,
              rel: 0,
            },
          },
        }}
      />
    </div>
  )
}

/******************************************************
	Data
******************************************************/
export const query = graphql`
  fragment VideoFields on Contentstack_video {
    id
    video_url
    caption
    internal {
      type
    }
  }
`
